var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00018 6.83325H17.0002L11.9902 13.1333L7.00018 6.83325ZM4.25018 6.44325C6.27018 9.03325 10.0002 13.8333 10.0002 13.8333V19.8333C10.0002 20.3833 10.4502 20.8333 11.0002 20.8333H13.0002C13.5502 20.8333 14.0002 20.3833 14.0002 19.8333V13.8333C14.0002 13.8333 17.7202 9.03325 19.7402 6.44325C20.2502 5.78325 19.7802 4.83325 18.9502 4.83325H5.04018C4.21018 4.83325 3.74018 5.78325 4.25018 6.44325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4e1974eb9d8349f905b3df5106b82b23.svg";
export { ForwardRef as ReactComponent };